/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Bank_InfoInputs */

const vi_invoice_bank_info = /** @type {(inputs: Invoice_Bank_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin ngân hàng`)
};

/**

* @param {Invoice_Bank_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_bank_info = /** @type {((inputs?: Invoice_Bank_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Bank_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_bank_info(inputs)
});